import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateTimer, resetTimer } from "../../app/features/timer/timerSlice";
import { useHistory } from "react-router-dom";

let timerInterval = null;

function CountdownTimer() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { remainingTime } = useSelector((state) => state.timer);
  const timerDistance = useSelector((state) => state.timer.distance);

  useEffect(() => {
    let initialDistance;

    if (timerDistance) {
      // Use existing remaining time
      initialDistance = timerDistance;
    } else {
      // Start fresh 15-minute timer
      initialDistance = 1000 * 60 * 15;
    }

    const countDownStart = new Date().getTime();
    
    timerInterval = setInterval(() => {
      const now = new Date().getTime();
      const distance = initialDistance - (now - countDownStart);

      if (distance <= 0) {
        clearInterval(timerInterval);
        dispatch(resetTimer());

        // Hide modal and navigate
        const myModal = document.getElementById("exampleModalToggle");
        if (myModal) {
          myModal.classList.remove("show");
          myModal.classList.add("hide");
          Array.from(document.getElementsByClassName("modal-backdrop")).forEach(
            (element) => element.parentNode.removeChild(element)
          );
          document.body.style.removeProperty("overflow");
          document.body.style.removeProperty("padding-right");
        }

        window.location.reload();
        return;
      }

      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      const formattedTime =
        minutes + " : " + (seconds < 10 ? "0" + seconds : seconds);

      dispatch(updateTimer({ distance, remainingTime: formattedTime }));
    }, 1000);

    return () => clearInterval(timerInterval); // Cleanup
  }, [dispatch, history, timerDistance]);

  return (
    <span className="remaining-time" id="detailPageTime">
      Time Remaining: {remainingTime}
    </span>
  );
}

export default CountdownTimer;
